import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export const updateNumDaysInDayRange = action('updateNumDaysInDayRange', (newValue: number) => {
    return addDatapointConfig(
        {
            name: 'updateNumDaysInDayRange',
            customData: { numDaysInDayRange: newValue },
        },
        { newValue }
    );
});
